exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui_msg[data-v-00e4705f] {\n  padding-top: 36px;\n  text-align: center;\n}\n.weui_icon_area[data-v-00e4705f]{\n  width:4rem;\n  height:4rem;\n  background-color:#10AEFF ;\n  border-radius: 4rem;\n  color:#fff;\n  font-size:50px ;\n  text-align: center;\n}\n.weui_text_area[data-v-00e4705f]{\n  margin-top: 36px;\n}\n.weui_msg .weui_msg_title[data-v-00e4705f] {\n  margin-bottom: 5px;\n  font-weight: 400;\n  font-size: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00e4705f","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Wechat_error.vue
// module id = L/iY
// module chunks = 1